import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "../lib/api";

export const useEignungQuestions = () => {
  const [data, setData] = useState({});
  useEffect(() => {
    api.get("/eignung/questions").then((r) => setData(r.data))
      .catch(() => setData({ error: true }));
  }, []);
  return data;
};

export const isEignungComplete = (questionsByTrack, track, answers) => {
  const qs = questionsByTrack?.[track]?.questions || [];
  return qs.length > 0 && qs.every((q) => q.options.includes(answers?.[q.id]));
};

export const EignungStep = ({ questionsByTrack, track, answers, onChange }) => {
  const cfg = questionsByTrack?.[track];
  if (questionsByTrack?.error)
    return (
      <p className="text-sm text-red-600" data-testid="eignung-error">
        Fragen konnten nicht geladen werden. Bitte Seite neu laden.
      </p>
    );
  if (!cfg) return null;
  const done = cfg.questions.filter((q) => answers?.[q.id]).length;
  const total = cfg.questions.length;
  return (
    <div data-testid="eignung-step">
      <div className="flex items-center justify-between mb-2">
        <p className="label-mono text-[color:var(--teal-dark)]">Angebot: {cfg.offer}</p>
        <p className="label-mono text-[color:var(--grey)]" data-testid="eignung-progress">
          {done} von {total} beantwortet
        </p>
      </div>
      <div className="h-1 rounded-full bg-[color:var(--border)] overflow-hidden mb-6">
        <div className="h-full bg-[color:var(--teal)] transition-[width] duration-300"
             style={{ width: `${(done / total) * 100}%` }} />
      </div>
      <div className="divide-y divide-[color:var(--border)]">
        {cfg.questions.map((q, i) => (
          <div key={q.id} className="py-5" data-testid={`eignung-q-${q.id}`}>
            <p className="font-semibold mb-3">{i + 1}. {q.text}</p>
            <div className="flex flex-wrap gap-2">
              {q.options.map((opt) => {
                const active = answers?.[q.id] === opt;
                return (
                  <button
                    key={opt}
                    type="button"
                    data-testid={`eignung-${q.id}-${opt.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => onChange({ ...(answers || {}), [q.id]: opt })}
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full border-2 text-sm font-semibold transition-colors ${
                      active
                        ? "border-[color:var(--teal)] bg-[color:var(--teal-light)] text-[color:var(--teal-dark)]"
                        : "border-[color:var(--border)] hover:border-[color:var(--teal)]/50"
                    }`}
                  >
                    {active && <Check size={14} />} {opt}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
